/**
 * Merges the first level keys of two objects
 * Safely handles cases where the base may be undefined (such as when it's optional in parent)
 *
 * While additional properties could be added at runtime the type will always be the base type
 */
export function shallowMerge<T extends Record<string, any> | undefined>(
  base: T,
  next: Partial<T>,
): NonNullable<T> {
  return {
    ...base,
    ...next,
  }
}
